import React from "react";
import { ProducerRevenueTransferSuccessModalTemplate } from "themes/application/producer/components";

function ProducerRevenueTransferSuccessModal(props) {
    return <ProducerRevenueTransferSuccessModalTemplate {...props} />;
}

export default ProducerRevenueTransferSuccessModal;
